export const INVESTMENT_STAGE = {
    ACTUAL:'ACTUAL',
    DECLARATION: 'DECLARATION',
    APPROVED: 'APPROVED'
};
export const EMPLOYEE_STAGE = {
    ACTUAL: 'Employees Actual',
    DECLARATION: 'Employee Declaration',
    APPROVED: 'Employee Approved'
} 
export const RESET_STAGE = {
    ACTUAL: 'Proof Of Investment',
    DECLARATION: 'IT Declaration'
}